import { ApiError, type IApiWithResponse, get } from '@tms/core'
import type {
  IBlogList,
  IBlogListParameter, IBusinessParameter,
  IBusinessProfileRes
} from '~/modules/business/types/business'

export default class BusinessService {
  /**
   * 기업 프로필 조회
   * @returns
   */
  async getMyBusinessProfile (): Promise<IBusinessProfileRes> {
    const response: IApiWithResponse<IBusinessProfileRes> = await get('/my/v1/business')
    return this.responseHandler(response)
  }

  /**
   * 기업 프로필 조회
   * @returns
   */
  async getBusinessProfile (param: IBusinessParameter): Promise<IBusinessProfileRes> {
    const response: IApiWithResponse<IBusinessProfileRes> = await get('/business/v1', param)
    return this.responseHandler(response)
  }

  /**
   * 마이페이지 비즈니스 콘텐츠 목록 조회
   * @param parameter
   * @param api
   */
  async getBlogList (parameter: IBlogListParameter, api: string): Promise<IBlogList> {
    const response: IApiWithResponse<IBlogList> = await get(api, parameter)
    return this.responseHandler(response)
  }

  private responseHandler<T, T2> (response: IApiWithResponse<T>): T2 {
    if (response.code === 0) { return response.data } else if (response.code === 102) { return response.data } else { throw new ApiError(response.message ?? '', response.code) }
  }
}
